import { realGetUserMenuList } from "./api/navmenu";
import { mockGetUserMenuList } from "./mock/navmenu";
import { mockableGetRequest } from "./mockable-api-request";
import { paths } from "./navmenu.types";

export const getUserMenuList = mockableGetRequest<
  paths["/exp/v1/dna/header/getUserMenuList"]
>(realGetUserMenuList, mockGetUserMenuList);
